"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationName = void 0;
var ApplicationName;
(function (ApplicationName) {
    ApplicationName["SIDEBAR"] = "sumo-sidebar";
    ApplicationName["SCHEDULER"] = "sumo-scheduler";
})(ApplicationName = exports.ApplicationName || (exports.ApplicationName = {}));
